// Walldora header davranışı: mega menü ve mobil çekmece.
// Mega menü kuralları design/README.md "Mega menu behavior":
//   açılma niyeti 100ms, kapanma niyeti 300ms, eksen değişince panel kapanmaz,
//   içerik 120ms'de geçer, Esc ve dışarı tıklama anında kapatır,
//   prefers-reduced-motion altında gecikmeler sıfırlanır.

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
const OPEN_INTENT = 100;
const CLOSE_INTENT = 300;
const intent = (ms) => (reducedMotion.matches ? 0 : ms);

function initMegaMenu(root) {
  const triggers = [...root.querySelectorAll("[data-wd-mega-trigger]")];
  const panels = new Map(
    [...root.querySelectorAll("[data-wd-mega-panel]")].map((p) => [p.dataset.wdMegaPanel, p])
  );
  if (!triggers.length) return;

  let current = null;
  let openTimer;
  let closeTimer;
  const clearTimers = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
  };

  function show(id, swapping) {
    root.classList.toggle("is-swapping", swapping);
    triggers.forEach((t) => t.setAttribute("aria-expanded", String(t.dataset.wdMegaTrigger === id)));
    panels.forEach((panel, key) => {
      panel.hidden = key !== id;
    });
    if (swapping) {
      const inner = panels.get(id)?.querySelector("[data-wd-mega-inner]");
      if (inner) {
        inner.classList.add("is-fading");
        requestAnimationFrame(() => requestAnimationFrame(() => inner.classList.remove("is-fading")));
      }
    }
    current = id;
  }

  function close({ restoreFocus = false } = {}) {
    clearTimers();
    if (!current) return;
    const trigger = triggers.find((t) => t.dataset.wdMegaTrigger === current);
    triggers.forEach((t) => t.setAttribute("aria-expanded", "false"));
    panels.forEach((panel) => {
      panel.hidden = true;
    });
    root.classList.remove("is-swapping");
    current = null;
    if (restoreFocus) trigger?.focus();
  }

  function intendOpen(id) {
    clearTimers();
    if (current === id) return;
    // Eksen değişince panel kapanmaz, içerik geçer
    if (current) {
      show(id, true);
      return;
    }
    openTimer = setTimeout(() => show(id, false), intent(OPEN_INTENT));
  }

  function intendClose() {
    clearTimers();
    closeTimer = setTimeout(() => close(), intent(CLOSE_INTENT));
  }

  // Eksen başlıkları link (/collections#eksen): fareyle tıklama gider, dokunmatikte ilk
  // dokunuş paneli açar, ikincisi gider. Design tools düğme: tıklama paneli açar
  let pointer = "mouse";
  triggers.forEach((trigger) => {
    const id = trigger.dataset.wdMegaTrigger;
    const isLink = trigger.tagName === "A";
    trigger.addEventListener("pointerdown", (event) => (pointer = event.pointerType));
    trigger.addEventListener("mouseenter", () => intendOpen(id));
    trigger.addEventListener("focus", () => intendOpen(id));
    trigger.addEventListener("click", (event) => {
      clearTimers();
      if (isLink) {
        if (pointer === "touch" && current !== id) {
          event.preventDefault();
          show(id, Boolean(current));
          return;
        }
        // Aynı sayfada çapaya gidiyorsa panel açık kalmasın
        close();
        return;
      }
      if (current !== id) show(id, Boolean(current));
    });
  });

  // Panele girmek zamanlayıcıyı iptal eder; şeritten veya panelden çıkmak kapatma niyetidir
  panels.forEach((panel) => panel.addEventListener("mouseenter", clearTimers));
  root.addEventListener("mouseleave", intendClose);
  root.querySelectorAll("[data-wd-mega-plain]").forEach((link) => link.addEventListener("mouseenter", intendClose));

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && current) close({ restoreFocus: true });
  });
  // Arama paneli açılınca mega menü kapanır, üst üste binmez
  document.addEventListener("wd:search-open", () => close());
  document.addEventListener("click", (event) => {
    if (current && !root.contains(event.target)) close();
  });
  root.addEventListener("focusout", (event) => {
    if (current && !root.contains(event.relatedTarget)) close();
  });
}

function initDrawer(drawer) {
  const openers = [...document.querySelectorAll("[data-wd-drawer-open]")];
  const closers = [...drawer.querySelectorAll("[data-wd-drawer-close]")];
  const back = drawer.querySelector("[data-wd-drawer-back]");
  const title = drawer.querySelector("[data-wd-drawer-title]");
  const logo = drawer.querySelector("[data-wd-drawer-logo]");
  const views = [...drawer.querySelectorAll("[data-wd-drawer-view]")];
  let lastFocus = null;

  function showView(id, label) {
    views.forEach((v) => {
      v.hidden = v.dataset.wdDrawerView !== id;
    });
    const atRoot = id === "root";
    back.hidden = atRoot;
    logo.hidden = !atRoot;
    title.textContent = atRoot ? "" : label;
    drawer.querySelector(".wd-drawer__body").scrollTop = 0;
  }

  function open() {
    lastFocus = document.activeElement;
    showView("root");
    drawer.inert = false;
    drawer.classList.add("is-open");
    document.documentElement.classList.add("wd-lock");
    openers.forEach((b) => b.setAttribute("aria-expanded", "true"));
    closers[closers.length - 1]?.focus();
  }

  function close() {
    drawer.classList.remove("is-open");
    drawer.inert = true;
    document.documentElement.classList.remove("wd-lock");
    openers.forEach((b) => b.setAttribute("aria-expanded", "false"));
    lastFocus?.focus();
  }

  openers.forEach((b) => b.addEventListener("click", open));
  closers.forEach((b) => b.addEventListener("click", close));
  back.addEventListener("click", () => {
    showView("root");
    back.focus();
  });
  drawer.querySelectorAll("[data-wd-drawer-sub]").forEach((row) =>
    row.addEventListener("click", () => {
      showView(row.dataset.wdDrawerSub, row.dataset.wdDrawerTitleText);
      back.focus();
    })
  );
  drawer.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
  });
  // Masaüstüne geçince açık çekmece kilidi bırakmasın
  window.matchMedia("(min-width: 900px)").addEventListener("change", (event) => {
    if (event.matches && drawer.classList.contains("is-open")) close();
  });
}

// Sepet rozeti: satır sayısı, sıfır hiç gösterilmez (F9). PDP ve sepet "wd:cart-updated" yayar
document.addEventListener("wd:cart-updated", (event) => {
  const link = document.querySelector("[data-wd-cart-link]");
  if (!link) return;
  const lines = event.detail?.lines ?? 0;
  let badge = link.querySelector(".wd-header__badge");
  if (lines > 0 && !badge) {
    badge = document.createElement("span");
    badge.className = "wd-header__badge";
    badge.setAttribute("aria-hidden", "true");
    link.append(badge);
  }
  if (badge) {
    badge.textContent = String(lines);
    badge.hidden = lines === 0;
  }
  const d = link.dataset;
  link.setAttribute("aria-label", lines === 0 ? d.labelEmpty : lines === 1 ? d.labelOne : d.labelOther.replace("%count", lines));
});

// Yapışkan header yüksekliği: yapışkan içerik (PDP galerisi) altında kalmasın.
// Ölçülen yükseklik tasarım değeri değil, --wd-* olmayan bir değişkene yazılır.
const headerEl = document.querySelector("[data-wd-header]");
if (headerEl && "ResizeObserver" in window) {
  new ResizeObserver(([entry]) => {
    document.documentElement.style.setProperty("--header-offset", `${Math.round(entry.borderBoxSize?.[0]?.blockSize ?? headerEl.offsetHeight)}px`);
  }).observe(headerEl);
}

const mega = document.querySelector("[data-wd-mega]");
if (mega) initMegaMenu(mega);
const drawer = document.querySelector("[data-wd-drawer]");
if (drawer) initDrawer(drawer);

// Ülke ve dil paneli (header ve footer, snippets/locale-picker): hesap paneliyle aynı davranış; seçim düğmesi formu
// kendisi gönderir
document.querySelectorAll("[data-wd-locale-menu]").forEach((localeMenu) => {
  const toggle = localeMenu.querySelector("[data-wd-locale-toggle]");
  const panel = localeMenu.querySelector("[data-wd-locale-panel]");
  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", String(open));
    if (open) panel.querySelector('[aria-current="true"]')?.scrollIntoView({ block: "nearest" });
  };
  toggle.addEventListener("click", () => setOpen(panel.hidden));
  document.addEventListener("click", (event) => {
    if (!panel.hidden && !localeMenu.contains(event.target)) setOpen(false);
  });
  localeMenu.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });
});

// Hesap paneli (DURUM "Hesap"): tıklayınca açılır, dışarı tık ve Esc kapatır
const account = document.querySelector("[data-wd-account]");
if (account) {
  const toggle = account.querySelector("[data-wd-account-toggle]");
  const panel = account.querySelector("[data-wd-account-panel]");
  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute("aria-expanded", String(open));
  };
  toggle.addEventListener("click", () => setOpen(panel.hidden));
  document.addEventListener("click", (event) => {
    if (!panel.hidden && !account.contains(event.target)) setOpen(false);
  });
  account.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });
}
